import docIcon from '~/assets/file-formats/doc-icon.svg?react'
import docxIcon from '~/assets/file-formats/docx-icon.svg?react'
import htmlIcon from '~/assets/file-formats/html-icon.svg?react'
import mdIcon from '~/assets/file-formats/md-icon.svg?react'
import pdfIcon from '~/assets/file-formats/pdf-icon.svg?react'
import txtIcon from '~/assets/file-formats/txt-icon.svg?react'
import typeIcon from '~/assets/file-formats/type-icon.svg?react'
import urlIcon from '~/assets/file-formats/url-icon.svg?react'

export const FileFormatIcons = {
  pdfIcon,
  docxIcon,
  docIcon,
  htmlIcon,
  mdIcon,
  typeIcon,
  urlIcon,
  txtIcon,
} as const
